<!-- Filter - Search - Form  -->
<div class="data-action-form">
  <div class="row justify-content-between align-items-end">
    <div>
      <h3 class="pl-3 mb-3">Union Locals</h3>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10">
      <div class="row mx-n2 align-items-end">
        <div class="col-12 col-sm-4 col-md col-lg-3 px-2 pb-2">
          <div class="form-group">
            <i>
              <span class="mr-2">Active Count : {{ activeCount }}</span>
              <span>Inactive Count : {{ inActiveCount }}</span>
            </i>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2">
          <div class="form-group">
            <label>Status</label>
            <select class="form-control select2" #status (change)="searchInTable(status.value, 'status')">
              <option selected="selected" value="">Select All</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
              <input type="text" [(ngModel)]="searchInfo.status" (blur)="searchInTable(status.value, 'status')" />
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2">
          <div class="search-box">
            <div class="form-group">
              <input
                type="text"
                name=""
                placeholder="Search"
                #search
                class="form-control fild"
                (keyup)="searchInTable(search.value, 'search')" />
              <a href="javascript:;" class="search"><i class="fas fa-search"></i></a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2" *ngIf="userPermissions.union_locals_setting.edit">
          <div class="search-box">
            <div class="form-group">
              <a href="javascript:;" class="btn btn-block btn-primary" (click)="generateCSV()">Export CSV</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md col-sm-2 px-2" *ngIf="userPermissions.union_locals_setting.edit">
          <div class="search-box">
            <div class="form-group">
              <a
                href="javascript:;"
                data-toggle="modal"
                data-target="#create-union-local"
                class="btn btn-block btn-primary"
                (click)="setMode('Add')"
                >Add Union Local</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Filter - Search - Form  End-->
<div class="table-responsive">
  <table class="table union-local-data-table mt-0">
    <thead>
      <tr>
        <th>Union Local#</th>
        <th>Description</th>
        <th>Employee Type</th>
        <th>Title</th>
        <th>Wage Rate</th>
        <th class="text-right">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of unionLocalsData">
        <td>{{ item.union_local_id }}</td>
        <td>{{ item.description }}</td>
        <td>{{ item.employee_type }}</td>
        <td>{{ item.title }}</td>
        <td>{{ item.wage_rate }}</td>
        <td class="text-right">
          <!-- Rounded switch -->
          <label
            *ngIf="userPermissions.union_locals_setting.view && userPermissions.union_locals_setting.edit"
            class="switch mr-2">
            <input
              type="checkbox"
              data-toggle="modal"
              data-target="#change-union-status"
              (click)="setUnionLocalStatusId($event, item)"
              [checked]="item.status == '1' ? 1 : 0" />
            <span class="slider round"></span>
          </label>
          <a
            *ngIf="userPermissions.union_locals_setting.view && userPermissions.union_locals_setting.edit"
            href="javascript:;"
            class="font-20 mr-2"
            data-toggle="modal"
            data-target="#create-union-local"
            (click)="setMode('Edit', item.id)"
            ><i class="far fa-pen"></i
          ></a>
          <a
            *ngIf="userPermissions.union_locals_setting.view && userPermissions.union_locals_setting.edit"
            href="javascript:void(0);"
            class="font-20"
            data-toggle="modal"
            data-target="#delete-union-local"
            title="Delete"
            (click)="setDeleteUserId(item.id)">
            <i class="far fa-trash"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Delete Union Local Modal -->
<div class="modal fade" id="delete-union-local" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              <b>{{ unionLocalNames[deleteUnionLocalId] }}</b
              ><br />
              Are you sure you would like to delete this union local?
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button type="button" class="btn btn-outline-primary width-fix" #closebutton1 data-dismiss="modal">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary width-fix" (click)="deleteUnionLocal(deleteUnionLocalId)">
            Delete Union Local
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Delete Union Local Modal End-->

<div class="modal fade" id="create-union-local">
  <div class="modal-dialog modal-xl">
    <form [formGroup]="unionLocalForm" (ngSubmit)="onSubmit(unionLocalForm)">
      <div class="modal-content jsUnionLocalForm">
        <div class="modal-header">
          <h4 class="modal-title">{{ mode }} Union Local: {{ unionLocalForm.get('description').value }}</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <input type="hidden" *ngIf="mode == 'Edit'" class="form-control" name="id" formControlName="id" />
          <!-- <input type="hidden" [value]="1" class="form-control" formControlName="status"> -->
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Union Local #<sup>*</sup></label>
                <input
                  type="text"
                  class="form-control"
                  id="union_local_id"
                  tabindex="1"
                  #union_local_id
                  formControlName="union_local_id"
                  autofocus
                  pattern="[a-zA-Z0-9]+"
                  (input)="setDataToControl('union_local_id', union_local_id.value)" />
                <span
                  class="error"
                  *ngIf="
                    unionLocalForm.get('union_local_id').hasError('required') &&
                    unionLocalForm.get('union_local_id').touched
                  ">
                  Please provide union local #
                </span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Union Local Description<sup>*</sup></label>
                <input type="text" class="form-control" formControlName="description" tabindex="2" />
                <span
                  class="error"
                  *ngIf="
                    unionLocalForm.get('description').hasError('required') && unionLocalForm.get('description').touched
                  ">
                  Please provide union local description
                </span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Select Status<sup>*</sup></label>
                <select class="form-control select2" formControlName="status" tabindex="3" #status1 id="editStatus">
                  <option value="">Status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
                <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
                  <input
                    type="text"
                    formControlName="status"
                    id="status1"
                    (blur)="setDataToControl('status', status1.value)" />
                </div>
                <span
                  class="error"
                  *ngIf="unionLocalForm.get('status').hasError('required') && unionLocalForm.get('status').touched">
                  Please select status
                </span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Employee Type<sup>*</sup></label>
                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{ grayText: employeeType.value == 'JobPointe' }"
                  formControlName="employee_type"
                  tabindex="4"
                  #employeeType />
                <span
                  class="error"
                  *ngIf="
                    unionLocalForm.get('employee_type').hasError('required') &&
                    unionLocalForm.get('employee_type').touched
                  ">
                  Please provide employee type
                </span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Title<sup>*</sup></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="title"
                  tabindex="5"
                  #title
                  [ngClass]="{ grayText: title.value == 'Info to Come' }" />
                <span
                  class="error"
                  *ngIf="unionLocalForm.get('title').hasError('required') && unionLocalForm.get('title').touched">
                  Please provide title
                </span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Wage Rate<sup>*</sup></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="wage_rate"
                  tabindex="6"
                  #wageRate
                  [ngClass]="{ grayText: wageRate.value == 'Info to Come' }" />
                <span
                  class="error"
                  *ngIf="
                    unionLocalForm.get('wage_rate').hasError('required') && unionLocalForm.get('wage_rate').touched
                  ">
                  Please provide wage rate
                </span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <span>* Required fields.</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary button-eh mb-3" #closebutton data-dismiss="modal">Close</button>
          <input type="submit" class="btn btn-primary button-eh mb-3" value="Save" />
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Change Union Local Status Modal -->
<div class="modal fade" id="change-union-status" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pb-0">
      <form action="#">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fal fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body pb-0 pt-0">
          <div class="notification-text text-center">
            <h4 class="font-weight-normal">
              <b>{{ statusUnionLocalItem && unionLocalNames[statusUnionLocalItem.id] }}</b
              ><br />
              Are you sure you want to change status?
            </h4>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0">
          <button
            type="button"
            class="btn btn-outline-primary width-fix"
            #closebutton2
            data-dismiss="modal"
            (click)="getUnionLocals()">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary width-fix"
            (click)="changeStatus(statusUnionLocalItem, unionLocalStatus)">
            Change Status
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Change Union Local Status Modal End-->
